import React from 'react';

import {
    AdjustTimeIcon,
    DashboardIcon,
    EmployeeIcon,
    FlowIcon,
    ProjectIcon,
    TableroIcon,
    TareaIcon,
    TimeControlIcon,
    TimeRecordIcon,
    UserIcon
} from 'core/icons';

const development = {
    //servidor: window.location.protocol + '//' + window.location.hostname,
    servidor: 'https://api.seguridadvialvallados.com',
    //puerto: '5051',
    puerto: '443',

    // Repositorio
    // Repositorio
    repository: 'https://api.seguridadvialvallados.com/api/repository',
    /*repository:
        window.location.protocol +
        '//' +
        window.location.hostname +
        ':5051' +
        '/api/repository',*/

    licencia: '',

    cliente: 'Seguridad Vial Vallados',

    // Imagenes
    rutaImagenes: `/recursos/imagenes`,
    rutaFuentes: `/recursos/fuentes`,
    rutaReports: `/recursos/reports`,
    imagenPortada: 'portada.png',
    logoCliente: 'logo-cliente.png',

    // Perfiles
    rutaPerfiles: '/recursos/perfiles',

    // Datos de la aplicacion
    aplicacion: {
        titulo: 'eSVV',
        descripcion: 'ERP Nubeis',
        copyright: 'itacasistemas',
        urlCopyRight: 'https://itacasistemas.com',
        año: 2025,
        cliente: `Seguridad Vial Vallados`
    },

    // Entidades
    entidades: [
        {
            entidad: 'Dashboard',
            title: 'Cuadro de Mandos',
            href: '/dashboard',
            icon: <DashboardIcon />
        },
        {
            entidad: 'RegistroHorario',
            title: 'Registro Horario',
            href: '/registrohorario',
            icon: <TimeRecordIcon />
        },
        {
            entidad: 'ControlPresencia',
            title: 'Control Presencia',
            href: '/controlpresencia',
            icon: <TimeControlIcon />
        },
        {
            entidad: 'Tableros',
            title: 'tablero',
            href: '/tablero',
            icon: <TableroIcon />
        },
        {
            entidad: 'Tareas',
            title: 'Tareas',
            href: '/tareas',
            icon: <TareaIcon />
        },
        {
            entidad: 'Proyectos',
            title: 'Proyectos',
            href: '/proyectos',
            icon: <ProjectIcon />
        },
        {
            entidad: 'Empleados',
            title: 'Empleados',
            href: '/empleados',
            icon: <EmployeeIcon />
        },
        {
            entidad: 'LiquidacionesEmpleados',
            title: 'Liq. Empleados',
            href: '/liquidacionesempleados',
            icon: <AdjustTimeIcon />
        }
        /*
    {
      entidad:'Grupos',
      title: 'Grupos de Operarios',
      href: '/grupos',
      icon: <GroupIcon/>
    }*/
    ],

    // Entidades de Sistema
    entSistema: [
        /*
    {
      entidad:'Equipos',
      title: 'Equipos Organización',
      href: '/equipos',
      icon: <TeamIcon />
    },
    {
      entidad:'Funcionalidades',
      title: 'Funcionalidades',
      href: '/funcionalidades',
      icon: <FunctionIcon />
    },
    {
      entidad:'Roles',
      title: 'Roles Usuario',
      href: '/roles',
      icon: <RolIcon/>
    },
    */
        {
            entidad: 'Usuarios',
            title: 'Usuarios',
            href: '/usuarios',
            icon: <UserIcon />
        },

        {
            entidad: 'Flujos',
            title: 'Flujos tareas',
            href: '/flujos',
            icon: <FlowIcon />
        }
    ]
};

export default development;
